import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Phone } from "lucide-react";
import { SITE, waLink } from "@/lib/site";

export const WhatsAppWidget = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-widget">
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 12, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }} transition={{ duration: 0.2 }}
            className="w-72 bg-white rounded-2xl shadow-2xl border border-border overflow-hidden"
            data-testid="whatsapp-widget-card">
            <div className="bg-[#075E54] text-white px-4 py-3">
              <p className="font-display font-bold">click2trip</p>
              <p className="text-xs text-white/70">Typically replies within minutes</p>
            </div>
            <div className="p-4 bg-[#ECE5DD]">
              <div className="bg-white rounded-lg rounded-tl-none p-3 text-sm shadow-sm max-w-[90%]">
                Hi there! Planning a trip? Tell us your dream destination and we'll craft it for you.
              </div>
            </div>
            <div className="p-3 flex flex-col gap-2">
              <a href={waLink("Hi click2trip! I'd like to plan a trip.")} target="_blank" rel="noreferrer"
                data-testid="whatsapp-widget-chat-btn"
                className="flex items-center justify-center gap-2 bg-[#25D366] text-white text-sm font-semibold py-2.5 rounded-full hover:bg-[#1fb857] transition-colors">
                <MessageCircle size={15} /> Start Chat
              </a>
              <a href={`tel:${SITE.phoneRaw}`} data-testid="whatsapp-widget-call-btn"
                className="flex items-center justify-center gap-2 text-sm font-medium text-ink/70 hover:text-sun py-1 transition-colors">
                <Phone size={14} /> Call {SITE.phoneDisplay}
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <motion.button whileHover={{ scale: 1.08 }} whileTap={{ scale: 0.92 }}
        onClick={() => setOpen(!open)} aria-label="WhatsApp chat"
        data-testid="whatsapp-widget-toggle"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-green-600/30">
        {open ? <X size={24} /> : <MessageCircle size={26} />}
      </motion.button>
    </div>
  );
};
